module.exports = __webpack_public_path__ + "media/images/front/icon_m_facebook-64de451a0f6997b5d5447e6c35137ee4.png";